import numeral from 'numeral'

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export function titleCase(str) {
  return str
    .split(' ')
    .map((w) => capitalize(w))
    .join(' ')
}

export function toTitleCase(str, separator = /[-_]/) {
  return str.split(separator).map(capitalize).join(' ')
}

export function snakeCaseToCamelCase(str) {
  return str
    .split('_')
    .map((name, i) => {
      if (i > 0) return capitalize(name)

      return name
    })
    .join('')
}

export function parseMagazineTitle(magazineTitle) {
  const [quarter, titleIssue] = magazineTitle.split(' | ')
  const [title, issue] = titleIssue.split(' - ')

  return [quarter, title, issue]
}

export function toNumberWithCommas(x, withDecimals: boolean = false) {
  return numeral(x).format(withDecimals ? '0,0.0' : '0,0')
}

export function makeTwitterSharableLink(url: string, title: string): string {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    url,
  )}&text=${encodeURI(title)}`
}

export function makeLinkedinSharableLink(url: string, title: string): string {
  return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
    url,
  )}&title=${encodeURI(title)}`
}

export function removeAnchorWithHref(text: string): string {
  const anchorTagRegexInit = /<a[^>]*href="[^"]*"[^>]*>/gi
  const sanitizeTextInit = text?.replaceAll(anchorTagRegexInit, '')
  const anchorTagRegexEnd = /<\/a>/gi
  return sanitizeTextInit?.replaceAll(anchorTagRegexEnd, '')
}

export const createElementFromString = (html: string): HTMLElement => {
  const root = document.createElement('div')
  root.innerHTML = html.trim()
  return root.firstChild as HTMLElement
}

export const camelToTitleCase = (str: string) => {
  if (!str) return str

  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([a-z])([0-9])/g, '$1$2')
    .replace(/([0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .replace(/([A-Z])(?=[A-Z])/g, '$1 ')
}

export const slugify = (str: string): string =>
  str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()

export const kebabToCamelCase = (str: string): string =>
  str.replace(/-./g, (x) => x[1]?.toUpperCase())
